import React, {Fragment} from 'react';
import image_404 from "../../../../assets/images/404_PNG.png";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    notFoundImage: {
        width: "100%",
        marginTop: "48px",
        height: "auto",
    },
    notFoundText: {
        color: "#004285",
        fontFamily: "EncodeSansBold",
        textAlign: "center",
        maxWidth: "100%",
        lineHeight: "1.3",
        marginTop: "48px",
        fontSize: "18px",

    },
    bodyDiv: {
        display: "flex",
        flexDirection: "column",
        width: "80%",
        justifyContent: "center",
        height: "100vh",
    },
}));

function InactiveBodyMobile() {
    const classes = useStyles();

    return (
        <Fragment>
            <div className={classes.bodyDiv}>
                <h2 className={classes.notFoundText}>Parece que su empresa no está recibiendo soporte de
                    Sancor Seguros en este momento.</h2>
                <img
                    className={classes.notFoundImage}
                    src={image_404}
                />
            </div>
        </Fragment>
    );
}

export default InactiveBodyMobile;